export default "__VITE_ASSET__cTtEL9ps__"